import { FilmTileFragment } from "@generated-types"
import { useRelatedItems } from "../useSearchClient"
import { FadeScroller } from "@components/atoms/FadeScroller"
import { FilmTile } from "@components/film/FilmTile"
import { SFFRagDocumentResultTypes } from "../../../server/search/rag"
import { AnimatePresence, motion } from "motion/react"
import { MiniFilmResult } from "./MiniFilmResult"

type Props = {
  id: number
  film: FilmTileFragment
}

export function RelatedFilmsWidget(props: Props) {
  const related = useRelatedItems({
    id: props.id,
    documentTypes: ["film"],
  })

  const films = related.data?.documents
    ?.filter((doc) => doc.type === "film")
    .slice(0, 6) as any as SFFRagDocumentResultTypes["film"][]

  return (
    <AnimatePresence>
      {films?.length > 3 && (
        <motion.div
          className="@container relative"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
        >
          <div className="py-6 border-t border-b border-bg-low my-4 group-first:mt-0 group-first:pt-0">
            <h3 className="type-label-caps pb-4">
              <span className="text-fg-secondary/80">Films similar to</span>{" "}
              <span className="text-fg">{props.film.title}</span>
            </h3>
            <FadeScroller fadeSize="lg">
              <div className="flex gap-3 w-min">
                {films.map((item) => {
                  return (
                    <div key={item.data.uri} className="w-[35cqw]">
                      <MiniFilmResult film={item.data} />
                    </div>
                  )
                })}
              </div>
            </FadeScroller>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
